import { useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { ControlledMultipleAutocomplete } from 'components/common/controller-wrapper'
import { useGetExceptionMetricsServiceCodesQuery } from 'generated/graphql'

import { ExceptionMetricsFilterValues } from './ExceptionMetricsFilterCriteria'
import { useExceptionMetricsQueryInput } from './useExceptionMetricsQueryInput'

export const ServiceCodeMultipleAutocomplete = () => {
  const { control } = useFormContext<ExceptionMetricsFilterValues>()
  const { start, end } = useExceptionMetricsQueryInput()

  const { data } = useGetExceptionMetricsServiceCodesQuery({
    variables: { input: { start, end } },
    skip: start == null || end == null,
  })

  const serviceCodes = useMemo(
    () =>
      [...(data?.exceptionMetricsServiceCodes ?? [])]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((code) => ({ value: code.id, label: code.name })),
    [data],
  )

  return (
    <ControlledMultipleAutocomplete
      control={control}
      name='selectedServiceCodes'
      label='Service code'
      options={serviceCodes}
      defaultValue={[]}
      limitTags={3}
      size='small'
      sx={{ minWidth: 220 }}
      noOptionsText='No service codes available in the selected period'
    />
  )
}
